<template>
    <div>
        <!-- 面包屑导航 -->
        <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item class="mybread">党员联系老师权限</el-breadcrumb-item>
                <el-breadcrumb-item class="mybread">学生名单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 第一行搜索框和新增按钮 -->
        <el-row type="flex" align="middle" class="myRow">
            <el-col :span="3">选择班级</el-col>
                    <el-col :span="7">
                        <el-select v-model="queryInfo.banji" placeholder="请选择" filterable @change="mygetUserList()">
                            <el-option v-for="item in banjiList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
            <el-col :span="3">用户搜索</el-col>
            <el-col :span="7">
                <el-input placeholder="请输入姓名" v-model="queryInfo.fullName" clearable>
                    <el-button slot="append" icon="el-icon-search" @click="mygetUserList()"></el-button>
                </el-input>
            </el-col>
        </el-row>
        <!-- 用户列表-->
        <el-table border stripe height="620px" :data="xsList"  :header-cell-style="{
			background: '#fff1f0', height: '60px', color: '#000000'
		}">
            <el-table-column type="index" label="序号" width="80px"> </el-table-column>

            <el-table-column prop="username" label="学号/工号" width="150px">
            </el-table-column>
            <el-table-column prop="fullName" label="姓名" width="150px">
            </el-table-column>
            <el-table-column prop="sex" label="性别" width="150px">
            </el-table-column>
            <el-table-column prop="minzu" label="民族" width="120x">
            </el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="220x">
            </el-table-column>
            <el-table-column prop="banji" label="班级" width="150x">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { getUserList, deleteUser, listLXLS,getUser } from "@/utils/api.js"

export default {
    data() {
        return {
            basicInfo: {
                fullName: '',
                username: '',

            },
            tempList: [],
            xsList:[],
            banjiList:[],
            queryInfo: {
                fullName: '',
                banji: '',
            },
            addActiForm: {
                type: '',
                name: '',
                date: '',
                score: ''
            },

        }
    },
    created() {
        this.info();
        
    },
    methods: {
        //获取到当前登录信息
        info() {
            getUser().then(result => {
                if (result.code === '0000') {
                    this.basicInfo = result.data;
                    this.mygetlistLXLS();
                    
                }
            })
        },
        mygetlistLXLS() {
            const param = { "username": this.basicInfo.username }
            listLXLS(param).then(result => {
                if (result.code === '0000') {
                    this.tempList = result.data;
                    for (let i in this.tempList){
                         this.banjiList.push({'key':this.tempList[i].banji,'value':this.tempList[i].banji})
					}
                    getUserList({banji:this.tempList[0].banji}).then(result => {
							if (result.code === '0000') {
								this.xsList = result.data[0];
            
							} else {
								console.log(result)
							}
					})
                } else {
                    console.log(result)
                }
            })
        },
        mygetUserList() {
            getUserList(this.queryInfo).then(result => {
                if (result.code === '0000') {
                  
                    this.xsList = result.data[0];

                } else {
                    console.log(result)
                }
            })
        },
    }
}
</script>

<style>
.title {
    font-size: 20px;
}

.basicInfo {
    height: 300px;
    width: 500px;
    background-color: bisque;
}

.el-button--primary {
    background-color: darkred;
    color: #fff;
    border-color: darkred;
    width: 130px;
    font-size: 18px;
}

.el-popover {
    padding: 10px !important;
    font-size: 18px !important;
    border: 1px solid gray !important;
    background-color: #f4eded !important;
    height: 50px;
}

.el-upload {
    width: 100%;
}

.el-upload .el-upload-dragger {
    width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
    color: grey;
    font-size: 18px;
}

.myRow {
    margin-top: 50px;
    margin-bottom: 30px;
    margin-left: 20px;
}

.el-tag+.el-tag {
    margin-left: 10px;
}
</style>